import PropTypes from 'prop-types';
import { clpFormatter } from '@/lib/format';
import './SelectionBar.css';

export default function SelectionBar({ count, total, onClear, onPay }) {
  return (
    <div className="selection-bar" data-testid="selection-bar">
      <span className="selection-bar__count">
        {count} seleccionada{count !== 1 ? 's' : ''}
      </span>
      <span className="selection-bar__total">
        {clpFormatter.format(total)}
        <span className="selection-bar__qual">total</span>
      </span>
      <span className="selection-bar__spacer" />
      <button
        type="button"
        className="selection-bar__clear"
        onClick={onClear}
        data-testid="selection-bar-clear"
      >
        Deseleccionar
      </button>
      <button
        type="button"
        className="btn btn-md btn-seal"
        onClick={onPay}
        data-testid="selection-bar-pay"
      >
        Pagar todo →
      </button>
    </div>
  );
}

SelectionBar.propTypes = {
  count: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onClear: PropTypes.func,
  onPay: PropTypes.func,
};
